import React, { createContext, useContext } from "react";
import { Menu, Dropdown, List, Tabs, Badge } from "antd";
import { NotificationOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import RequestStore from "../../../productiondata/approvals/store/requeststore";
import MainStore from "../../store/mainStore";
import { toJS } from "mobx";
import moment from "moment";
import _ from "underscore";
import { useNavigate } from "react-router";
import { Link } from "@fluentui/react";
import { Mail } from "react-feather";
const mainStorectx = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);
const { TabPane } = Tabs;

const Actions = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const mainStore = useContext(mainStorectx);
  const navigate = useNavigate();

  const notificationDropdown = (
    <Menu>
      <Tabs defaultActiveKey="1">
        <TabPane
          tab={
            <>
              <span>Naoc </span>
              <Badge
                count={
                  _.where(
                    [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                    { assetId: 1, approvalStatus: 1 }
                  ).length
                }
              />
            </>
          }
          key="1"
        >
          {_.where(
            [...requestStore.allApprovals.values()].map((a) => toJS(a)),
            { assetId: 1, approvalStatus: 1 }
          ).length > 0 ? (
            <List
              size="small"
              bordered={false}
              dataSource={_.where(
                [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                { assetId: 1, approvalStatus: 1 }
              )}
              renderItem={(item) => (
                <List.Item>
                  <Link
                    onClick={() => {
                      mainStore.assetContextId = 1;
                      requestStore.statusId=1;
                      mainStore.assetContextName = "NAOC";
                      navigate("/production/workflow/approval");
                      console.log("clicked");
                    }}
                  >
                    Production Entry Sign-Off Request for{" "}
                    {moment(item.productionDate).format("ddd DD MMM,YYYY")}
                  </Link>
                </List.Item>
              )}
            />
          ) : (
            <div style={{ padding: "5px" }}>
              <div
                className="antd-pro-components-notice-icon-notice-list-notFound"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Mail size={80} color="#F0F2F5" />
              </div>
              <div>You have No pending approval request in Naoc workspace.</div>
            </div>
          )}
        </TabPane>
        <TabPane
          tab={
            <>
              <span>Ebendo </span>
              <Badge
                count={
                  _.where(
                    [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                    { assetId: 2, approvalStatus: 1 }
                  ).length
                }
              />
            </>
          }
          key="2"
        >
          {_.where(
            [...requestStore.allApprovals.values()].map((a) => toJS(a)),
            { assetId: 2, approvalStatus: 1 }
          ).length > 0 ? (
            <List
              size="small"
              bordered={false}
              dataSource={_.where(
                [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                { assetId: 2, approvalStatus: 1 }
              )}
              renderItem={(item) => (
                <List.Item>
                  <Link
                    onClick={() => {
                      requestStore.statusId = 1;
                      mainStore.assetContextId = 2;
                      mainStore.assetContextName = "EBENDO";
                      navigate("/production/workflow/approval");
                    }}
                  >
                    Production Entry Sign-Off Request for{" "}
                    {moment(item.productionDate).format("ddd DD MMM,YYYY")}
                  </Link>
                </List.Item>
              )}
            />
          ) : (
            <div style={{ padding: "5px" }}>
              <div
                className="antd-pro-components-notice-icon-notice-list-notFound"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Mail size={80} color="#F0F2F5" />
              </div>
              <div>
                You have No pending approval request in Ebendo workspace.
              </div>
            </div>
          )}
        </TabPane>

        <TabPane
          tab={
            <>
              <span>Quaibo </span>
              <Badge
                count={
                  _.where(
                    [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                    { assetId: 3, approvalStatus: 1 }
                  ).length
                }
              />
            </>
          }
          key="3"
        >
          {_.where(
            [...requestStore.allApprovals.values()].map((a) => toJS(a)),
            { assetId: 3, approvalStatus: 1 }
          ).length > 0 ? (
            <List
              size="small"
              bordered={false}
              dataSource={_.where(
                [...requestStore.allApprovals.values()].map((a) => toJS(a)),
                { assetId: 3 }
              )}
              renderItem={(item) => (
                <List.Item>
                  <Link
                    onClick={() => {
                      requestStore.statusId = 1;
                      mainStore.assetContextId = 3;
                      mainStore.assetContextName = "QUAIBO";
                      navigate("/production/workflow/approval");
                    }}
                  >
                    Production Entry Sign-Off Request for{" "}
                    {moment(item.productionDate).format("ddd DD MMM,YYYY")}
                  </Link>
                </List.Item>
              )}
            />
          ) : (
            <div style={{ padding: "5px" }}>
              <div
                className="antd-pro-components-notice-icon-notice-list-notFound"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Mail size={80} color="#F0F2F5" />
              </div>
              <div>
                You have No pending approval request in Quaibo workspace.
              </div>
            </div>
          )}
        </TabPane>
      </Tabs>
    </Menu>
  );
  return (
    <div
      className="ms-Grid-col ms-sm12"
      style={{ cursor: "pointer!important", marginLeft: "-20px" }}
    >
      <Dropdown overlay={notificationDropdown} trigger={["click"]}>
        <Badge
          count={requestStore.allApprovals.size}
          style={{
            cursor: "pointer!important",
            boxShadow: "0 0 0 1px red",
          }}
        >
          <NotificationOutlined style={{ color: "white" }} />
        </Badge>
      </Dropdown>
    </div>
  );
});
export default Actions;

